import React, {useContext} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {UsacmContext} from "../App";
import {downloadCourseSalesReport, downloadCourseUsageReport} from "../api/CourseApi";
import {getConfLabel, titleCase} from "../utils/usacmUtils";
import {CONF_LABEL_KEY_COURSE} from "../constants";
import '../misc/Reports.scss';

/**
 * Course Settings -> Reports (course admins only)
 */
export function CourseSettingsReports() {
  const context = useContext(UsacmContext);
  const [conf,] = context.conference;
  const courseLabel = titleCase(getConfLabel(conf, CONF_LABEL_KEY_COURSE));

  return (
    <div className="d-flex flex-column align-items-start">
      <div className="report-line" onClick={() => downloadCourseSalesReport()}>
        <div className="d-flex align-items-center">
          <FontAwesomeIcon icon="fa-file-excel" size="2x" className="me-3 excel-green"/> Sales Report
        </div>
      </div>
      <div className="report-line" onClick={() => downloadCourseUsageReport()}>
        <div className="d-flex align-items-center">
          <FontAwesomeIcon icon="fa-file-excel" size="2x" className="me-3 excel-green"/> {courseLabel} Usage Report
        </div>
      </div>
    </div>
  );
}
